import styled from 'styled-components';

import {
    CommonAction,
    floorGameDuration as duration,
    floorGameEasing as easing,
    recipesCommonAction,
    styledMedia,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from '../../DataTable.tokens';
import { type DataTableDirection } from '../../DataTable.types';

interface StyledSortActionProps {
    $direction?: DataTableDirection;
}

export const StyledSortAction = styled(CommonAction)<StyledSortActionProps>`
    ${recipesCommonAction.basic};

    --data-table-sort-action-up-color: ${({ $direction }) =>
        $direction === 'ascending' ? 'white' : 'rgb(255, 255, 255, 0.4)'};
    --data-table-sort-action-down-color: ${({ $direction }) =>
        $direction === 'descending' ? 'white' : 'rgb(255, 255, 255, 0.4)'};

    gap: ${tokens.sortAction.spacing}px;
    padding: ${tokens.sortAction.spacing}px;
    border-radius: ${tokens.sortAction.spacing}px;

    &:disabled {
        opacity: 0.8;
    }

    &[aria-pressed] {
        background-color: rgb(255, 255, 255, 0.06);
    }

    &:hover {
        background-color: rgb(255, 255, 255, 0.1);
    }

    &:active {
        background-color: rgb(255, 255, 255, 0.06);
    }
`;

export const Label = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.sortAction.fontSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.sortAction.iconSize}px;
    height: ${tokens.sortAction.iconSize}px;

    path {
        transition: fill ${duration.normal}ms ${easing.cubic};
    }

    path:first-child {
        fill: var(--data-table-sort-action-up-color);
    }

    path:last-child {
        fill: var(--data-table-sort-action-down-color);
    }
`;
